module.exports = __webpack_public_path__ + "static/media/4.5c5757e3.JPG";